"use strict";
var $ = require("../internals/export");
var $values = require("../internals/object-to-array").values;
$({ target: "Object", stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});
